import { Box } from '@bridebook/ui';
import componentStyles from './overlay.style';

/*
 * This covers the whole container and prevents the user from interacting with
 * elements inside that container, while preserving the scroll, which can be
 * useful for example for page preview
 */
const Overlay = () => {
  const styles = componentStyles();

  return <Box style={styles.wrapper} />;
};

export default Overlay;
